import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.assets');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type AssetType = 'companies' | 'general_status' | 'personnel' | 'projects' | 'images';

interface AssetFile {
    id: string;
    file_type: string;
    original_filename: string;
    relative_path: string;
    mime_type: string;
    file_size: number;
    created_at: string;
}

interface Asset {
    id: string;
    asset_type: string;
    name: string;
    description: string;
    metadata: any;
    created_at: string;
    updated_at: string;
    files: AssetFile[];
    file_count: number;
}

const COMPANY_TYPE_LABEL: any = {
    self: '자사',
    consortium: '컨소시엄',
    outsource: '외주',
};

const ROLE_CATEGORIES = ['Executive', 'PM', 'Developer', 'Designer', 'DataScientist', '기타'];
const PROJECT_ROLES = ['주관사', '핵심 수행사', '참여사', '기술지원'];

const COMPANY_TYPE_ORDER: any = { self: 0, consortium: 1, outsource: 2 };
const PERSONNEL_RANK: any = { '대표이사': 0, '대표': 0, '이사': 1, '팀장': 2 };

const TYPE_API: any = {
    companies: '/api/assets/companies',
    general_status: '/api/assets/general_status',
    personnel: '/api/assets/personnel',
    projects: '/api/assets/projects',
    images: '/api/assets/images',
};

const ALLOWED_EXT = ['.md', '.pdf', '.txt', '.doc', '.docx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp'];

@Component({
    selector: 'wiz-page-assets',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.assets/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #fafafa;
}

.assets-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 24px 60px;
}

.assets-header {
  margin-bottom: 16px;
  border-bottom: 1px solid #e4e4e7;
}

.assets-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.assets-title-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.assets-title-left h1 {
  font-size: 16px;
  font-weight: 700;
  color: #18181b;
  margin: 0;
}

.assets-title-sub {
  font-size: 11.5px;
  color: #71717a;
  margin-left: 4px;
}

.assets-title-stats {
  display: flex;
  gap: 6px;
}

.stat-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: #f4f4f5;
  color: #52525b;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.assets-tabs {
  display: flex;
  gap: 2px;
  overflow-x: auto;
}

.assets-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  font-weight: 600;
  color: #71717a;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  margin-bottom: -1px;
}
.assets-tab:hover {
  color: #18181b;
  background: #f4f4f5;
}
.assets-tab.active {
  color: #0f766e;
  border-bottom-color: #0f766e;
  background: rgba(236, 253, 245, 0.3);
}

.assets-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 10px;
  font-weight: 700;
}
.assets-tab.active .assets-tab-count {
  background: #0f766e;
  color: #fff;
}

.assets-body {
  padding-top: 18px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.toolbar-hint {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: #f4f4f5;
  border-radius: 6px;
  font-size: 11px;
  color: #52525b;
}

.search-input {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0 10px;
  height: 32px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  transition: border-color 0.15s;
}
.search-input:focus-within {
  border-color: #99f6e4;
}
.search-input input {
  background: transparent;
  border: 0;
  outline: 0;
  font-size: 12px;
  color: #18181b;
  width: 180px;
}
.search-input input::placeholder {
  color: #a1a1aa;
}

.select {
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  font-size: 12px;
  color: #52525b;
  cursor: pointer;
  transition: border-color 0.15s;
}
.select:hover {
  border-color: #d4d4d8;
}
.select:focus {
  outline: 0;
  border-color: #99f6e4;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 6px;
  background: #0f766e;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-primary:hover {
  background: #0b5f59;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.view-mode-toggle {
  display: inline-flex;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  overflow: hidden;
}

.view-mode-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 10px;
  background: #ffffff;
  border: 0;
  color: #71717a;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
}
.view-mode-btn:hover {
  background: #f4f4f5;
}
.view-mode-btn.active {
  background: #ecfdf5;
  color: #0f766e;
  font-weight: 600;
}
.view-mode-btn + .view-mode-btn {
  border-left: 1px solid #e4e4e7;
}

.state-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 60px 20px;
  font-size: 12px;
  color: #71717a;
}

.state-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 60px 20px;
  background: #ffffff;
  border: 1px dashed #e4e4e7;
  border-radius: 12px;
}

.state-empty-title {
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
}

.state-empty-desc {
  font-size: 12px;
  color: #71717a;
  margin-bottom: 6px;
}

.card-grid {
  display: grid;
  gap: 8px;
}

.card {
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  transition: all 0.15s;
}
.card:hover {
  border-color: #99f6e4;
  box-shadow: 0 1px 4px rgba(15, 118, 110, 0.08);
}

.card-row {
  align-items: center;
}

.card-thumb {
  flex-shrink: 0;
  border-radius: 6px;
  background: #f4f4f5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-thumb-square {
  width: 56px;
  height: 56px;
}

.card-thumb-rect {
  width: 96px;
  height: 64px;
}

.card-thumb-amber {
  background: #fffbeb;
}

.card-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card-head {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.3;
}

.card-desc {
  font-size: 12px;
  color: #52525b;
  line-height: 1.45;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-desc-2line {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px;
  color: #71717a;
  flex-wrap: wrap;
}
.card-meta .meta-dim {
  color: #a1a1aa;
  margin-left: auto;
}

.card-meta-inline {
  font-size: 11px;
  color: #71717a;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.badge {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
}

.badge-blue {
  background: #ccfbf1;
  color: #0f766e;
}

.badge-emerald {
  background: #d1fae5;
  color: #047857;
}

.badge-stone {
  background: #f4f4f5;
  color: #52525b;
}

.badge-amber {
  background: #fef3c7;
  color: #b45309;
}

.badge-indigo {
  background: #e0e7ff;
  color: #4338ca;
}

.icon-btn {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.icon-btn:hover {
  background: #f4f4f5;
  color: #18181b;
}
.icon-btn.icon-btn-danger:hover {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626;
}

.icon-btn-tiny {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 0;
  background: rgba(255, 255, 255, 0.92);
  color: #52525b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.icon-btn-tiny:hover {
  background: #fff;
  color: #18181b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.icon-btn-tiny.icon-btn-danger:hover {
  color: #dc2626;
}

.org-chart {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

@media (max-width: 900px) {
  .org-chart {
    grid-template-columns: 1fr;
  }
}
.org-tree {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 10px 8px;
  max-height: 600px;
  overflow-y: auto;
}

.org-row {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 6px 8px;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.12s;
}
.org-row:hover {
  background: #f4f4f5;
}

.org-row-name {
  font-size: 12px;
  color: #18181b;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-row-count {
  font-size: 10px;
  color: #71717a;
  background: #f4f4f5;
  padding: 1px 7px;
  border-radius: 999px;
  font-weight: 600;
}

.org-row-pos {
  font-size: 10px;
  color: #71717a;
  margin-left: 4px;
}

.org-row-company .org-row-name {
  font-weight: 600;
}

.org-row-team .org-row-name {
  color: #52525b;
}

.org-row-person {
  padding-left: 24px;
}
.org-row-person .org-row-name {
  font-weight: 500;
}
.org-row-person.active {
  background: #ecfdf5;
}
.org-row-person.active .org-row-name {
  color: #0f766e;
  font-weight: 600;
}
.org-row-person.active .org-row-pos {
  color: rgba(15, 118, 110, 0.7);
}
.org-row-person:hover:not(.active) {
  background: #f4f4f5;
}

.org-company-body {
  padding-left: 12px;
}

.org-team-body {
  padding-left: 8px;
}

.org-detail {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 16px;
  min-height: 240px;
}

.org-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 240px;
  color: #71717a;
}

.org-detail-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.org-detail-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.org-detail-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f4f4f5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.org-detail-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.org-detail-meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.org-detail-name {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.org-detail-name span:first-child {
  font-size: 15px;
  font-weight: 700;
  color: #18181b;
}

.org-detail-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 11px;
  color: #52525b;
}

.org-detail-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.org-detail-desc {
  font-size: 12px;
  color: #52525b;
  line-height: 1.55;
  white-space: pre-line;
  padding-top: 6px;
  border-top: 1px solid #f4f4f5;
}

.org-detail-files {
  padding-top: 6px;
  border-top: 1px solid #f4f4f5;
}

.org-detail-files-label {
  font-size: 10px;
  color: #71717a;
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.org-detail-files-list {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.file-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  font-size: 11px;
  color: #52525b;
  text-decoration: none;
  transition: all 0.15s;
}
.file-chip:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #ecfdf5;
}

.file-chip-size {
  color: #71717a;
  font-size: 10px;
}

.card-person {
  flex-direction: column;
  gap: 8px;
  align-items: stretch;
}

.card-person-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-person-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f4f4f5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.card-person-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-person-name {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.card-person-pos {
  font-size: 11px;
  color: #71717a;
}

.card-person-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 11px;
  color: #52525b;
  padding-top: 6px;
  border-top: 1px solid #f4f4f5;
}

.card-project {
  align-items: stretch;
}

.image-grid {
  display: grid;
  gap: 10px;
}

.image-cell {
  position: relative;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.15s;
}
.image-cell:hover {
  border-color: #99f6e4;
  box-shadow: 0 1px 6px rgba(15, 118, 110, 0.1);
}
.image-cell:hover .image-actions {
  opacity: 1;
}

.image-thumb {
  aspect-ratio: 4/3;
  background: #f4f4f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.image-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s;
}

.image-name {
  padding: 6px 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 11px;
  color: #18181b;
}
.image-name span:first-child {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-tags {
  color: #0f766e;
  font-size: 10px;
  font-weight: 500;
}

.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 22px;
  text-align: center;
  color: #64748b;
  transition: all 0.15s ease;
  cursor: pointer;
  background: #f8fafc;
}
.dropzone.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

/* App-wide visual alignment */
.assets-page {
  color: #18181b;
  font-size: 12px;
}

.assets-header {
  padding-bottom: 12px;
}

.assets-title-left i {
  color: #0f766e !important;
}

.assets-title-left h1 {
  font-size: 16px;
}

.assets-title-sub,
.toolbar-hint,
.card-desc,
.card-meta,
.card-meta-inline,
.org-detail-info,
.org-detail-desc,
.card-person-meta {
  font-size: 11.5px;
}

.stat-pill,
.assets-tab-count,
.badge,
.file-chip,
.image-name,
.image-tags {
  font-size: 10.5px;
}

.assets-tab {
  height: 34px;
  color: #71717a;
}
.assets-tab:hover {
  color: #18181b;
  background: #fafafa;
}
.assets-tab.active {
  color: #0f766e;
  border-bottom-color: #0f766e;
  background: rgba(236, 253, 245, 0.72);
}

.assets-tab.active .assets-tab-count {
  background: #0f766e;
}

.toolbar {
  margin-bottom: 12px;
}

.search-input,
.select,
.btn-primary {
  height: 30px;
  font-size: 11.5px;
}

.search-input:focus-within,
.select:focus {
  border-color: #99f6e4;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.08);
}

.btn-primary {
  background: #0f766e;
}
.btn-primary:hover {
  background: #0b5f59;
}

.view-mode-btn {
  height: 28px;
  font-size: 10.5px;
}
.view-mode-btn.active {
  background: #ecfdf5;
  color: #0f766e;
}

.card {
  padding: 10px;
  box-shadow: none;
}
.card:hover {
  border-color: #99f6e4;
  box-shadow: 0 1px 4px rgba(15, 118, 110, 0.08);
}

.card-title,
.state-empty-title {
  font-size: 12px;
  font-weight: 650;
}

.card-thumb-square {
  width: 50px;
  height: 50px;
}

.icon-btn {
  width: 24px;
  height: 24px;
}

.org-detail-name span:first-child {
  font-size: 13px;
}

.image-cell:hover {
  border-color: #99f6e4;
  box-shadow: 0 1px 4px rgba(15, 118, 110, 0.08);
}

.dropzone {
  border-color: #d4d4d8;
  border-radius: 8px;
  background: #fafafa;
}
.dropzone.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}`],
})
export class PageAssetsComponent implements OnInit {

    constructor(@Inject( Service) public service: Service) { }

    public loading: any = { companies: true, general_status: true, personnel: true, projects: true, images: true };
    public search: any = { companies: '', general_status: '', personnel: '', projects: '', images: '' };
    public projectFilter: any = { domain: '', year: '', clientType: '' };

    public data: any = {
        companies: [] as Asset[],
        general_status: [] as Asset[],
        personnel: [] as Asset[],
        projects: [] as Asset[],
        images: [] as Asset[],
    };

    // Upload/Edit dialog state
    public dialog: any = {
        open: false,
        type: '' as AssetType | '',
        mode: 'create' as 'create' | 'edit',
        id: '',
        name: '',
        description: '',
        meta: {} as any,
        existingFiles: [] as AssetFile[],
        newFiles: [] as File[],
        deleteFileIds: [] as string[],
        dragActive: false,
        submitting: false,
        error: '',
    };

    // Delete confirm state
    public delDialog: any = {
        open: false,
        type: '' as AssetType | '',
        id: '',
        name: '',
        confirmText: '',
        submitting: false,
        error: '',
    };

    // Toast
    public toast: any = { show: false, message: '', kind: 'success' };

    public companyTypeLabel = COMPANY_TYPE_LABEL;
    public companyTypes = ['self', 'consortium', 'outsource'];
    public roleCategories = ROLE_CATEGORIES;
    public projectRoles = PROJECT_ROLES;

    // Active category tab (single-view design)
    public activeTab: AssetType = 'companies';
    // Sort options per category
    public sortKey: any = {
        companies: 'type',          // type | name | updated
        general_status: 'updated',  // updated | name
        personnel: 'name',          // name | position | updated
        projects: 'featured',       // featured | year | name
        images: 'updated',          // updated | name
    };
    public viewMode: any = {
        personnel: 'tree',          // tree | grid
        images: 'grid',             // grid | list
    };

    public categories: { id: AssetType, label: string, icon: string, hint: string }[] = [
        { id: 'companies',      label: '회사 정보',  icon: 'fa-building',     hint: '자사·컨소시엄·외주 회사 정보' },
        { id: 'general_status', label: '일반현황',   icon: 'fa-chart-pie',    hint: '회사 소개·재무·조직 자료' },
        { id: 'personnel',      label: '인력',       icon: 'fa-users',        hint: '투입 가능한 인력 풀' },
        { id: 'projects',       label: '프로젝트 실적', icon: 'fa-briefcase', hint: '과거 수행 프로젝트' },
        { id: 'images',         label: '이미지',     icon: 'fa-images',       hint: '제안서 활용 스크린샷' },
    ];

    public setTab(tab: AssetType) {
        this.activeTab = tab;
        // 인력 탭 진입 시 첫 회사·팀 자동 펼침
        if (tab === 'personnel') {
            const tree = this.personnelTree();
            if (tree.length > 0 && Object.keys(this.expandedCompanies).length === 0) {
                this.expandedCompanies[tree[0].name] = true;
                if (tree[0].teams.length > 0) {
                    this.expandedTeams[tree[0].name + '|' + tree[0].teams[0].name] = true;
                }
            }
        }
        this.service.render();
    }

    public setSort(tab: AssetType, key: string) {
        this.sortKey[tab] = key;
        this.data[tab] = this.sortRowsByKey(tab, this.data[tab]);
        this.service.render();
    }

    public setViewMode(tab: 'personnel' | 'images', mode: string) {
        this.viewMode[tab] = mode;
        this.service.render();
    }

    public categoryCount(id: AssetType): number {
        if (id === 'projects') return this.filteredProjects().length;
        return (this.data[id] || []).length;
    }

    private sortRowsByKey(type: AssetType, rows: Asset[]): Asset[] {
        const key = this.sortKey[type];
        const arr = [...(rows || [])];
        if (type === 'companies') {
            if (key === 'name') return arr.sort((a, b) => a.name.localeCompare(b.name));
            if (key === 'updated') return arr.sort((a, b) => (b.updated_at || '').localeCompare(a.updated_at || ''));
            return arr.sort((a, b) => {
                const oa = COMPANY_TYPE_ORDER[a.metadata?.company_type] ?? 9;
                const ob = COMPANY_TYPE_ORDER[b.metadata?.company_type] ?? 9;
                if (oa !== ob) return oa - ob;
                return a.name.localeCompare(b.name);
            });
        }
        if (type === 'personnel') {
            if (key === 'position') return arr.sort((a, b) => {
                const ra = PERSONNEL_RANK[a.metadata?.position] ?? 9;
                const rb = PERSONNEL_RANK[b.metadata?.position] ?? 9;
                if (ra !== rb) return ra - rb;
                return a.name.localeCompare(b.name);
            });
            if (key === 'updated') return arr.sort((a, b) => (b.updated_at || '').localeCompare(a.updated_at || ''));
            return arr.sort((a, b) => a.name.localeCompare(b.name));
        }
        if (type === 'projects') {
            if (key === 'year') return arr.sort((a, b) => {
                const ya = parseInt(a.metadata?.year || '0') || 0;
                const yb = parseInt(b.metadata?.year || '0') || 0;
                return yb - ya;
            });
            if (key === 'name') return arr.sort((a, b) => a.name.localeCompare(b.name));
            return arr.sort((a, b) => {
                const fa = a.metadata?.featured ? 1 : 0;
                const fb = b.metadata?.featured ? 1 : 0;
                if (fa !== fb) return fb - fa;
                const ya = parseInt(a.metadata?.year || '0') || 0;
                const yb = parseInt(b.metadata?.year || '0') || 0;
                return yb - ya;
            });
        }
        if (key === 'name') return arr.sort((a, b) => a.name.localeCompare(b.name));
        return arr.sort((a, b) => (b.updated_at || '').localeCompare(a.updated_at || ''));
    }

    public async ngOnInit() {
        await this.service.init();
        await Promise.all([
            this.load('companies'),
            this.load('general_status'),
            this.load('personnel'),
            this.load('projects'),
            this.load('images'),
        ]);
        // 조직도 기본 펼침: 모든 회사 펼치고, 각 첫 팀까지 펼침
        const tree = this.personnelTree();
        for (const c of tree) {
            this.expandedCompanies[c.name] = true;
            if (c.teams.length > 0) {
                this.expandedTeams[c.name + '|' + c.teams[0].name] = true;
            }
        }
        await this.service.render();
    }

    // -------------------------------------------------------------------------
    // 데이터 로딩
    // -------------------------------------------------------------------------
    public async load(type: AssetType) {
        this.loading[type] = true;
        await this.service.render();
        try {
            const params = new URLSearchParams();
            if (this.search[type]) params.append('text', this.search[type]);
            params.append('dump', '200');
            const res = await fetch(`${TYPE_API[type]}?${params.toString()}`, {
                method: 'GET',
                credentials: 'same-origin',
            });
            const json = await res.json();
            if (json.code === 200) {
                let rows: Asset[] = json.data.rows || [];
                rows = this.sortRows(type, rows);
                this.data[type] = rows;
            } else {
                this.showToast(json.data?.message || '불러오기 실패', 'error');
            }
        } catch (e: any) {
            this.showToast(e?.message || '네트워크 오류', 'error');
        }
        this.loading[type] = false;
        await this.service.render();
    }

    private sortRows(type: AssetType, rows: Asset[]): Asset[] {
        return this.sortRowsByKey(type, rows);
    }

    public filteredProjects(): Asset[] {
        let rows = this.data.projects as Asset[];
        const f = this.projectFilter;
        if (f.domain) rows = rows.filter(r => (r.metadata?.domain || '') === f.domain);
        if (f.year) rows = rows.filter(r => String(r.metadata?.year || '') === String(f.year));
        if (f.clientType) rows = rows.filter(r => (r.metadata?.client_type || '') === f.clientType);
        return rows;
    }

    public projectDomains(): string[] {
        const set = new Set<string>();
        for (const r of this.data.projects as Asset[]) {
            if (r.metadata?.domain) set.add(r.metadata.domain);
        }
        return Array.from(set).sort();
    }

    public projectYears(): string[] {
        const set = new Set<string>();
        for (const r of this.data.projects as Asset[]) {
            if (r.metadata?.year) set.add(String(r.metadata.year));
        }
        return Array.from(set).sort((a, b) => parseInt(b) - parseInt(a));
    }

    public projectClientTypes(): string[] {
        const set = new Set<string>();
        for (const r of this.data.projects as Asset[]) {
            if (r.metadata?.client_type) set.add(r.metadata.client_type);
        }
        return Array.from(set).sort();
    }

    // -------------------------------------------------------------------------
    // 회사 목록 (인력 드롭다운용)
    // -------------------------------------------------------------------------
    public companyNames(): string[] {
        const names = (this.data.companies as Asset[]).map(c => c.name);
        if (!names.includes('(주)시즌')) names.unshift('(주)시즌');
        return names;
    }

    // -------------------------------------------------------------------------
    // 조직도 (FN-0018): 회사 > 팀 계층으로 인력을 그룹화
    // -------------------------------------------------------------------------
    public expandedCompanies: any = {};   // companyName -> bool (펼침 상태)
    public expandedTeams: any = {};       // companyName + '|' + teamName -> bool
    public selectedPersonnelId: string = '';

    public personnelTree(): any[] {
        const map: any = {};
        const all = (this.data.personnel as Asset[]).filter(p => {
            if (!this.search.personnel) return true;
            const q = this.search.personnel.toLowerCase();
            return (p.name || '').toLowerCase().includes(q)
                || (p.metadata?.position || '').toLowerCase().includes(q)
                || (p.metadata?.team || '').toLowerCase().includes(q);
        });
        for (const p of all) {
            const company = p.metadata?.company || '미분류';
            const team = p.metadata?.team || '미분류';
            if (!map[company]) map[company] = { name: company, count: 0, teams: {} };
            if (!map[company].teams[team]) map[company].teams[team] = { name: team, members: [] };
            map[company].teams[team].members.push(p);
            map[company].count++;
        }
        const result: any[] = [];
        for (const cname of Object.keys(map).sort()) {
            const node = map[cname];
            const teamsArr = Object.keys(node.teams).sort().map(tn => node.teams[tn]);
            result.push({ name: cname, count: node.count, teams: teamsArr });
        }
        return result;
    }

    public toggleCompanyNode(name: string) {
        this.expandedCompanies[name] = !this.expandedCompanies[name];
        this.service.render();
    }

    public toggleTeamNode(company: string, team: string) {
        const k = company + '|' + team;
        this.expandedTeams[k] = !this.expandedTeams[k];
        this.service.render();
    }

    public isTeamExpanded(company: string, team: string): boolean {
        return !!this.expandedTeams[company + '|' + team];
    }

    public selectPersonnel(p: Asset) {
        this.selectedPersonnelId = p.id;
        this.service.render();
    }

    public selectedPersonnel(): Asset | null {
        if (!this.selectedPersonnelId) return null;
        return (this.data.personnel as Asset[]).find(p => p.id === this.selectedPersonnelId) || null;
    }

    public existingTeams(): string[] {
        const set = new Set<string>();
        for (const p of this.data.personnel as Asset[]) {
            if (p.metadata?.team) set.add(p.metadata.team);
        }
        return Array.from(set).sort();
    }

    // -------------------------------------------------------------------------
    // 파일 URL 헬퍼
    // -------------------------------------------------------------------------
    public fileUrl(asset: Asset, file: AssetFile): string {
        const t = asset.asset_type;
        return `/api/assets/${t}/${asset.id}/files/${file.id}`;
    }

    public thumbnailFor(asset: Asset, fallbackType: 'image' | 'document' = 'image'): string {
        const files = asset.files || [];
        // image 우선
        const img = files.find(f => f.file_type === 'image');
        if (img) return this.fileUrl(asset, img);
        if (fallbackType === 'image') {
            const any = files.find(f => /\.(png|jpg|jpeg|gif|webp|svg)$/i.test(f.original_filename));
            if (any) return this.fileUrl(asset, any);
        }
        return '';
    }

    public formatDate(s: string): string {
        if (!s) return '';
        return s.substring(0, 10);
    }

    public humanSize(n: number): string {
        if (!n) return '0 B';
        const u = ['B', 'KB', 'MB', 'GB'];
        let i = 0;
        let v = n;
        while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
        return `${v.toFixed(v < 10 ? 1 : 0)} ${u[i]}`;
    }

    // -------------------------------------------------------------------------
    // 다이얼로그 열기/닫기
    // -------------------------------------------------------------------------
    public openCreate(type: AssetType) {
        this.dialog = {
            open: true,
            type,
            mode: 'create',
            id: '',
            name: '',
            description: '',
            meta: this._defaultMeta(type),
            existingFiles: [],
            newFiles: [],
            deleteFileIds: [],
            dragActive: false,
            submitting: false,
            error: '',
        };
        this.service.render();
    }

    public openEdit(type: AssetType, asset: Asset) {
        this.dialog = {
            open: true,
            type,
            mode: 'edit',
            id: asset.id,
            name: asset.name,
            description: asset.description || '',
            meta: { ...this._defaultMeta(type), ...(asset.metadata || {}) },
            existingFiles: [...(asset.files || [])],
            newFiles: [],
            deleteFileIds: [],
            dragActive: false,
            submitting: false,
            error: '',
        };
        this.service.render();
    }

    public closeDialog() {
        this.dialog.open = false;
        this.service.render();
    }

    private _defaultMeta(type: AssetType): any {
        if (type === 'companies') return { company_type: 'consortium', ceo: '', founded: '', employees: '' };
        if (type === 'general_status') return { category: '', period: '' };
        if (type === 'personnel') return { company: '(주)시즌', team: '', position: '', role_category: 'Developer', years: '' };
        if (type === 'projects') return { client: '', client_type: '', domain: '', year: '', our_role: '주관사', featured: false };
        if (type === 'images') return { tags: '' };
        return {};
    }

    // -------------------------------------------------------------------------
    // 파일 입력
    // -------------------------------------------------------------------------
    public onFileSelect(ev: any) {
        const files: FileList = ev?.target?.files;
        if (!files) return;
        this._addFiles(Array.from(files));
        ev.target.value = '';
        this.service.render();
    }

    public onDragOver(ev: DragEvent) {
        ev.preventDefault();
        this.dialog.dragActive = true;
    }
    public onDragLeave(ev: DragEvent) {
        ev.preventDefault();
        this.dialog.dragActive = false;
    }
    public onDrop(ev: DragEvent) {
        ev.preventDefault();
        this.dialog.dragActive = false;
        if (!ev.dataTransfer?.files) return;
        this._addFiles(Array.from(ev.dataTransfer.files));
        this.service.render();
    }

    private _addFiles(files: File[]) {
        const valid: File[] = [];
        for (const f of files) {
            const ext = '.' + f.name.split('.').pop()!.toLowerCase();
            if (!ALLOWED_EXT.includes(ext)) {
                this.showToast(`허용되지 않은 확장자: ${ext}`, 'error');
                continue;
            }
            const limit = ext === '.pdf' ? 50 * 1024 * 1024 : 20 * 1024 * 1024;
            if (f.size > limit) {
                this.showToast(`파일 크기 초과: ${f.name}`, 'error');
                continue;
            }
            valid.push(f);
        }
        this.dialog.newFiles = [...this.dialog.newFiles, ...valid];
        this.service.render();
    }

    public removeNewFile(idx: number) {
        this.dialog.newFiles.splice(idx, 1);
        this.service.render();
    }

    public toggleDeleteExisting(fileId: string) {
        const list: string[] = this.dialog.deleteFileIds;
        const i = list.indexOf(fileId);
        if (i >= 0) list.splice(i, 1);
        else list.push(fileId);
        this.service.render();
    }

    public isMarkedDelete(fileId: string): boolean {
        return this.dialog.deleteFileIds.indexOf(fileId) >= 0;
    }

    // -------------------------------------------------------------------------
    // 제출 (생성/수정)
    // -------------------------------------------------------------------------
    public async submit() {
        const d = this.dialog;
        if (!d.name?.trim()) { d.error = '이름을 입력하세요'; await this.service.render(); return; }
        d.error = '';
        d.submitting = true;
        await this.service.render();

        const type = d.type as AssetType;
        try {
            let assetId = d.id;
            if (d.mode === 'create') {
                const fd = new FormData();
                fd.append('name', d.name.trim());
                fd.append('description', d.description || '');
                fd.append('metadata', JSON.stringify(d.meta || {}));
                for (const f of d.newFiles as File[]) fd.append('files', f, f.name);
                const res = await fetch(`${TYPE_API[type]}`, { method: 'POST', body: fd, credentials: 'same-origin' });
                const json = await res.json();
                if (json.code !== 200) throw new Error(json.data?.message || '생성 실패');
                assetId = json.data.asset.id;
                if (json.data.warning) this.showToast(`등록되었지만 일부 파일 오류: ${json.data.warning}`, 'error');
                else this.showToast(`${d.name}이(가) 추가되었습니다`, 'success');
            } else {
                // 메타 업데이트
                const fd = new FormData();
                fd.append('name', d.name.trim());
                fd.append('description', d.description || '');
                fd.append('metadata', JSON.stringify(d.meta || {}));
                const res = await fetch(`${TYPE_API[type]}/${assetId}`, { method: 'PUT', body: fd, credentials: 'same-origin' });
                const json = await res.json();
                if (json.code !== 200) throw new Error(json.data?.message || '수정 실패');

                // 기존 파일 삭제
                for (const fid of d.deleteFileIds as string[]) {
                    await fetch(`${TYPE_API[type]}/${assetId}/files/${fid}`, { method: 'DELETE', credentials: 'same-origin' });
                }
                // 신규 파일 추가
                if ((d.newFiles as File[]).length > 0) {
                    const fd2 = new FormData();
                    for (const f of d.newFiles as File[]) fd2.append('files', f, f.name);
                    await fetch(`${TYPE_API[type]}/${assetId}/files`, { method: 'POST', body: fd2, credentials: 'same-origin' });
                }
                this.showToast(`${d.name}이(가) 수정되었습니다`, 'success');
            }
            d.open = false;
            await this.load(type);
        } catch (e: any) {
            d.error = e?.message || '오류';
            this.showToast(d.error, 'error');
        }
        d.submitting = false;
        await this.service.render();
    }

    // -------------------------------------------------------------------------
    // 삭제
    // -------------------------------------------------------------------------
    public openDelete(type: AssetType, asset: Asset) {
        this.delDialog = {
            open: true,
            type,
            id: asset.id,
            name: asset.name,
            confirmText: '',
            submitting: false,
            error: '',
        };
        this.service.render();
    }

    public closeDelete() {
        this.delDialog.open = false;
        this.service.render();
    }

    public async confirmDelete() {
        const d = this.delDialog;
        if (d.confirmText !== d.name) {
            d.error = '자산 이름이 일치하지 않습니다';
            await this.service.render();
            return;
        }
        d.error = '';
        d.submitting = true;
        await this.service.render();
        try {
            const res = await fetch(`${TYPE_API[d.type]}/${d.id}`, { method: 'DELETE', credentials: 'same-origin' });
            const json = await res.json();
            if (json.code !== 200) throw new Error(json.data?.message || '삭제 실패');
            this.showToast(`${d.name}이(가) 삭제되었습니다`, 'success');
            d.open = false;
            await this.load(d.type as AssetType);
        } catch (e: any) {
            d.error = e?.message || '오류';
            this.showToast(d.error, 'error');
        }
        d.submitting = false;
        await this.service.render();
    }

    // -------------------------------------------------------------------------
    // Toast
    // -------------------------------------------------------------------------
    private _toastTimer: any = null;
    public showToast(message: string, kind: 'success' | 'error' = 'success') {
        this.toast = { show: true, message, kind };
        this.service.render();
        if (this._toastTimer) clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => {
            this.toast.show = false;
            this.service.render();
        }, 3500);
    }
}

export default PageAssetsComponent;